import { useTranslation } from 'next-i18next';

import css from '@/src/legal/presentation/views/privacy-policy-page-view/privacy-policy-page-view.css';

export default function LegalNoticePageView() {
  const { t } = useTranslation('legal', { keyPrefix: 'views.legal_notice' });

  return (
    <div className={css.page}>
      <h1 className={css.title}>{t('title')}</h1>

      <p dangerouslySetInnerHTML={{ __html: t('message') }}></p>
    </div>
  );
}
